import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useNotificationUnreadCount } from '~/hooks/useNotifications';
import { NotificationPanel } from './NotificationPanel';

type NotificationBellProps = {
  enabled?: boolean;
};

function formatBadgeCount(count: number): number | string {
  if (count <= 0) return 0;
  if (count > 99) return '99+';
  return count;
}

export function NotificationBell({ enabled = true }: NotificationBellProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { data: unreadCount = 0 } = useNotificationUnreadCount(enabled);

  const badgeContent = useMemo(() => formatBadgeCount(unreadCount), [unreadCount]);
  const panelOpen = Boolean(anchorEl);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    if (panelOpen) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleToggle}
        aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread` : ''}`}
        aria-expanded={panelOpen}
        aria-haspopup="true"
      >
        <Badge badgeContent={badgeContent} color="error" invisible={unreadCount === 0}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationPanel
        anchorEl={anchorEl}
        open={panelOpen}
        onClose={handleClose}
        enabled={enabled}
      />
    </>
  );
}
